import { render, staticRenderFns } from "./labelPrint.vue?vue&type=template&id=a55a8c6a&scoped=true"
import script from "./labelPrint.vue?vue&type=script&lang=js"
export * from "./labelPrint.vue?vue&type=script&lang=js"
import style0 from "./labelPrint.vue?vue&type=style&index=0&id=a55a8c6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55a8c6a",
  null
  
)

export default component.exports